import type { ReactNode } from 'react';
import { useTranslate } from '@refinedev/core';
import { Button, Space } from 'antd';

type FilterPanelProps = {
  onFilter: () => void;
  onReset: () => void;
  children: ReactNode;
};

/** Dropdown body shared by the column filters: the control plus Filter/Reset. */
export const FilterPanel = ({
  onFilter,
  onReset,
  children,
}: FilterPanelProps) => {
  const t = useTranslate();

  return (
    <div
      style={{ padding: 8, display: 'flex', flexDirection: 'column', gap: 8 }}
    >
      {children}
      <Space>
        <Button type="primary" size="small" onClick={onFilter}>
          {t('buttons.filter', 'Filtruj')}
        </Button>
        <Button size="small" onClick={onReset}>
          {t('buttons.reset', 'Resetuj')}
        </Button>
      </Space>
    </div>
  );
};
